"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    sideNavItem: {
      textTransform: "none",
      padding: theme.spacing(1.5, 4),
      letterSpacing: "0",
      wordWrap: "break-word",
      "&:before": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        width: ".33rem",
        height: "75%",
        display: "block",
        background: "transparent",
        transform: "translateY(-16%)",
        transition: theme.transitions.create("background")
      },
      "&:hover": {
        background: theme.palette.action.hover
      },
      "&$selected": {
        "&:before": {
          background: theme.palette.primary.main
        }
      }
    },
    productNavItem: {
      "& *": {
        fontSize: ".85rem"
      },
      "& svg": {
        maxHeight: "1rem",
        verticalAlign: "text-bottom"
      },
      "&:before": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        width: ".33rem",
        height: "75%",
        display: "block",
        background: "transparent",
        transform: "translateY(-16%)",
        transition: theme.transitions.create("background")
      },
      "&:hover": {
        background: "rgba(0,0,0,.02)",
        "&:before": {
          background: theme.palette.primary.main
        }
      }
    },
    selected: {},
    secondaryAction: {
      position: "static",
      top: "auto",
      right: "auto",
      transform: "none",
      display: "flex"
    }
  };
};

exports.styles = styles;